{
  "paymentInformation": "Betalningsuppgifter",
  "paymentReferences": "Referenser och kontonummer",
  "paymentHistory": "Betalningshistoria",
  "currentMonth": "Innevarande månad",
  "invoices": "Fakturor",
  "itemisation": "Betalningsspecifikation",
  "payer": "Betalare",
  "dueDate": "Förfallodag",
  "sum": "Belopp",
  "sumTotal": "Totalt",
  "remittances": "Betalningar",
  "refund": "Återbetalning",
  "transfer": "Överföring",
  "withheldFrom": {
    "securityDeposit": "Avdrag från depositionsavgift",
    "depositVoucher": "Avdrag från betalningsförbindelse",
    "rooFee": "Avdrag från bostadsrättsavgift"
  },
  "paidDate": "Betalda",
  "noTargets": "Inga fakturarader",
  "creditNote": "Kredit",
  "noRemittances": "Inga betalningar",
  "arrearTotal": "Totalt belopp som ska betalas",
  "advanceTotal": "Totalt förskott",
  "arrearTotalForMonth": "Att betala {{month}}",
  "advanceTotalForMonth": "Förskott {{month}}",
  "neutralTotal": "Totalt",
  "saldo": "Saldo",
  "paymentTypeCategory": {
    "chargesForUtilities": "Bruksavgift",
    "rent": "Hyra",
    "residenceCharge": "Bruksvederlag",
    "rightOfOccupancyDeposit": "Bostadsrättsavgift",
    "securityDeposit": "Depositionsavgift",
    "interest": "Ränta",
    "generic": "Allmän",
    "rightOfOccupancyNewDevelopmentDeposit": "Bostadsrättsavgift för nybyggnad"
  },
  "paymentsBeneficiary": "Mottagare",
  "referenceNumber": "Fakturornas referensnummer",
  "noAccountData": "Kontouppgifter saknas",
  "errors": {
    "failedToLoadPaymentInfo": "Det gick inte att ladda betalningsuppgifterna",
    "failedToLoadPaymentHistory": "Det gick inte att ladda betalningshistorian",
    "paymentsAccessDenied": "Du har inte tillräckliga behörigheter att se betalningsuppgifterna för detta avtal."
  }
}
